var queryString = require('query-string');

var templateCart = require('pug-loader!../../../views/blocks/cart.pug');
var templateCartMobile = require('pug-loader!../../../views/blocks/navbar/cart-mobile.pug');
var templateCheckoutCart = require('pug-loader!../../../views/cart/blocks/cart.pug');
var templateProductPage = require('pug-loader!../../../views/product/components/product-section-single-page.pug');
const cartConfirmationModal = require('pug-loader!../../../views/blocks/modals/added-to-cart-confirmation.pug');

var config;
var that;
var CartController = {
  settings: {},

  init: function() {
    that = this;
    config = this.settings;
    this.bindUIElements();

    if ($('#product-details').length) {
      that.checkIfInCart();
    }
  },

  bindUIElements: function() {
    var _t = this;

    window.addEventListener(
      'triggerUpdateQuantity',
      function(e) {
        // e.target matches elem

        _t.updateProductQuantityInCart(e.detail.prod_id, e.detail.qty)
          .then(function(data) {
            _t.updateNavbarCart(data);
            _t.updateCartPage(data);
            $(window).trigger('initQuantityInputs');

            $('.delete-item-cart')
              .on('click', that.removeFromCart)
              .addClass('init');
            return;
          })
          .catch(function(err) {
            // console.log(err);
          });
        //get quantity and prod_id and make post request
      },
      false
    );

    //add to cart
    $('#add-to-cart, .add-to-cart').submit(function(ev) {
      ev.preventDefault();

      jQuery('#cart-error').addClass('hidden');

      let $form = $(this),
        url = $form.attr('action');

      //if not window.prod_id get data from form
      let productId = window.prod_id
        ? window.prod_id
        : $(this)
            .find('input[name=product_id]')
            .val();

      /* Send the data using post with element id name and name2*/
      jQuery
        .ajax({
          type: 'POST',
          url: url,
          data: $form.serialize()
        })
        .then(function(data) {
          that.openConfirmationModal(data, parseInt(productId));
          that.updateNavbarCart(data);

          if ($('#product-details').length) {
            return that.updateProductPage(data);
          }

          throw Error('No data received');
        })
        .catch(data => {
          console.log(data);
          jQuery('#cart-error').removeClass('hidden');
          // console.log('complete');
        });

      /* Alerts the results */
      // posting.done(function (data) {
      //     alert('success');
      // });
    });

    $(window).trigger('initQuantityInputs');

    $('#remove-from-cart-trigger').click(function(ev) {
      ev.preventDefault();
      // var prodId = window.prod_id;
      jQuery
        .ajax({
          type: 'delete',
          url: '/cart',
          data: {
            // quantity: 0,
            product_id: window.prod_id
          }
        })
        .then(function(data) {
          // that.openConfirmationModal(data, parseInt(productId));
          _t.updateNavbarCart(data);

          if ($('#product-details').length) {
            $('#add-to-cart-trigger')
              .removeClass('btn-success')
              .val('Add to cart');
            $('#quantity-in-cart').html('');
            $('#remove-from-cart-wrapper').addClass('hidden');
          }

          return;
          // console.log('done');
          // console.log(data);
        })
        .catch(function(data) {
          // console.log('complete');
          // console.log(data);
        });
    });

    //remove from cart
    $('.delete-item-cart')
      .on('click', that.removeFromCart)
      .addClass('init');
  },

  openConfirmationModal: function(data, prod_id) {
    $('body').append('<div id="confirmation-modal" class="modal fade" tab-index="-1"></div>');

    let locals = {
      cart: data,
      prod_id: prod_id,
      productAdded: (function() {
        for (let i = 0; i < data.cart.items.length; i++) {
          if (data.cart.items[i].prod_id === prod_id) {
            return data.cart.items[i];
            break;
          }
        }
      })()
    };
    var html = cartConfirmationModal(locals);
    $('#confirmation-modal').html(html);

    $('#confirmation-modal').modal('show');
  },

  updateNavbarCart: function(data) {
    var locals = data;

    var html = templateCart(locals);
    $('#shopping-cart').html(html);

    var htmlMobile = templateCartMobile(locals);
    $('#navbar-mobile-cart').html(htmlMobile);
    // console.log(locals);
    $('.cart-items-number-mobile').html(locals.cart.items_number);
  },

  updateProductQuantityInCart: function(product_id, qty) {
    return jQuery.ajax({
      type: 'POST',
      url: '/cart/update_quantity',
      data: {
        product_id,
        qty
      }
    });
  },

  removeFromCart: function(ev) {
    ev.preventDefault();
    var id = $(ev.currentTarget).attr('data-id');

    jQuery
      .ajax({
        type: 'DELETE',
        url: '/cart',
        data: {
          product_id: id
        }
      })
      .then(function(data) {
        that.updateNavbarCart(data);
        that.updateCartPage(data);
        that.bindUIElements();

        return;
        // console.log("done");
        // console.log(data);
      })
      .catch(function(data) {
        // console.log('complete');
        // console.log(data);
      });
  },

  updateProductPage: function(data) {
    //update page if needed
    that.checkIfInCart(data);
  },

  checkIfInCart: function(ajaxData) {
    var cart = window.cart;

    if (ajaxData) {
      cart = ajaxData.cart;
    }

    if (cart) {
      if (cart.items) {
        for (var i = 0; i < cart.items.length; i++) {
          if (window.prod_id == cart.items[i].prod_id) {
            that.changeText(cart.items[i].quantity);
          }
        }
      }
    }

    return false;
  },

  changeText: function(quantity) {
    $('#add-to-cart-trigger')
      .addClass('btn-success')
      .val('Add More');
    $('#quantity-in-cart').html(quantity);
    $('#remove-from-cart-wrapper').removeClass('hidden');
  },

  updateCartPage: function(data) {
    var locals = data;
    var html = templateCheckoutCart(locals);
    $('#checkout-cart-item').html(html);

    $('#loading-cart-items-loader').fadeOut();
  }
};

module.exports = CartController;



// WEBPACK FOOTER //
// ./public/src/js/cart.js